const LIST_QUERY = `
  query ListGroups($paginationParams: PaginationInput!) {
    listGroups(pagination: $paginationParams) {
      objects {
        uuid
        name
        description
        notifyEmails
        authenticator
        credential {
          type
          name
          uuid
        }
        users {
          username
        }
        devices {
          serialNumber
          name
        }
      }
      totalRows
    }
  }
`
const CREATE_MUTATION = `
  mutation CreateGroup(
    $name: String!,
    $description: String!,
    $emails: [String]
    ) {
    createGroup(params: {
      name: $name
      description: $description
      notifyEmails: $emails
    }) {
      uuid
    }
  }
`
const UPDATE_DETAIL_MUTATION = `
  mutation UpdateGroupDetails(
    $uuid: String!,
    $name: String,
    $description: String,
    $emails: [String]
    $authenticator: AuthenticatorType
    $credentialUUID: String
    ) {
    updateGroup(params: {
      uuid: $uuid
      name: $name
      description: $description
      notifyEmails: $emails
      authenticator: $authenticator
      credentialUUID: $credentialUUID
    })
  }
`

const ADD_USER_MUTATION = `
  mutation UpdateGroupUsers($uuid: String!, $users: [String]) {
    updateGroup(params: {
      uuid: $uuid
      addUsers: $users
    })
  }
`

const ADD_DEVICES_MUTATION = `
  mutation UpdateGroupDevices($uuid: String!, $devices: [String]) {
    updateGroup(params: {
      uuid: $uuid
      addDevices: $devices
    })
  }
`

const DELETE_USER_MUTATION = `
  mutation DeleteGroupUsers($uuid: String!, $deleteUsers: [String]) {
    updateGroup(params: {
      uuid: $uuid
      deleteUsers: $deleteUsers
    })
  }
`

const DELETE_DEVICES_MUTATION = `
  mutation DeleteGroupDevices($uuid: String!, $deleteDevices: [String]) {
    updateGroup(params: {
      uuid: $uuid
      deleteDevices: $deleteDevices
    })
  }
`

const DELETE_MUTATION = `
  mutation DeleteGroup($uuid: String!) {
    deleteGroup(uuid: $uuid)
  }
`

const groupQueries = {
  methods: {
    async listGroupsQuery(paginationParams) {
      try {
        const _result = await this.graphQuery(LIST_QUERY, {paginationParams})
        const {objects: groupList, totalRows} = _result.listGroups
        return {groupList, totalRows}
      } catch (error) {
        throw new Error(error)
      }
    },
    async createGroupMutation(groupDetails) {
      try {
        const _result = await this.graphQuery(CREATE_MUTATION, groupDetails)
        return _result.createGroup.uuid
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteGroupMutation(groupDetails) {
      try {
        const _result = await this.graphQuery(DELETE_MUTATION, groupDetails)
        return _result
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateGroupDetailsMutation(groupDetails) {
      const {uuid, name, description, authenticator, emails} = groupDetails
      const _detailsPayload = {
        uuid,
        name,
        description,
        emails,
        authenticator: authenticator.type,
        credentialUUID: authenticator.uuid,
      }
      try {
        return await this.graphQuery(UPDATE_DETAIL_MUTATION, _detailsPayload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateGroupAddUsersMutation(uuid, users) {
      try {
        return await this.graphQuery(ADD_USER_MUTATION, {uuid, users})
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateGroupAddDevicesMutation(uuid, devices) {
      try {
        return await this.graphQuery(ADD_DEVICES_MUTATION, {uuid, devices})
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateGroupDeleteUsersMutation(uuid, deleteUsers) {
      try {
        return await this.graphQuery(DELETE_USER_MUTATION, {uuid, deleteUsers})
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateGroupDeleteDevicesMutation(uuid, deleteDevices) {
      try {
        return await this.graphQuery(DELETE_DEVICES_MUTATION, {uuid, deleteDevices})
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default groupQueries
